var KEY_0 = 48;
var KEY_1 = 49;
var KEY_2 = 50;
var KEY_3 = 51;
var KEY_4 = 52;
var KEY_5 = 53;
var KEY_6 = 54;
export var HEADING_KEYS = [KEY_0, KEY_1, KEY_2, KEY_3, KEY_4, KEY_5, KEY_6];
var NUMPAD_KEY_0 = 96;
var NUMPAD_KEY_1 = 97;
var NUMPAD_KEY_2 = 98;
var NUMPAD_KEY_3 = 99;
var NUMPAD_KEY_4 = 100;
var NUMPAD_KEY_5 = 101;
var NUMPAD_KEY_6 = 102;
export var HEADING_NUMPAD_KEYS = [NUMPAD_KEY_0, NUMPAD_KEY_1, NUMPAD_KEY_2, NUMPAD_KEY_3, NUMPAD_KEY_4, NUMPAD_KEY_5, NUMPAD_KEY_6];